import React from 'react';
import { createRoot } from 'react-dom/client';import './index.css';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import "bootswatch/dist/darkly/bootstrap.min.css";
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import 'react-leaflet-cluster/dist/assets/MarkerCluster.css';
import 'react-leaflet-cluster/dist/assets/MarkerCluster.Default.css';
import 'react-calendar-timeline/style.css';
import * as serviceWorker from './serviceWorker';
import { CookiesProvider } from 'react-cookie';
import Shelterly from './Shelterly';
import { AuthProvider } from "./accounts/AccountsReducer";
import { SystemErrorProvider } from './components/SystemError';
// import {
//   NodeManager,
// } from "react-register-nodes";

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<CookiesProvider><AuthProvider><SystemErrorProvider><Shelterly /></SystemErrorProvider></AuthProvider></CookiesProvider>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
